// extracted by mini-css-extract-plugin
module.exports = {"recall":"page_recall__88w1e"};